import {
  GET_BANK_ACCOUNT,
  UPDATE_BANK_ACCOUNT_SAGA,
  DELETE_BANK_ACCOUNT_SAGA
} from './actionsTypes';

const actions = {
  initData: () => ({ type: GET_BANK_ACCOUNT }),
  updateBankAccount: bankAccount => {
    return (dispatch, getState) => {
      const bankAccounts = getState().BankAccounts.bankAccounts;
      const index = bankAccounts.map(inv => inv._id).indexOf(bankAccount._id);
      if (index === -1) {
        bankAccounts.unshift(bankAccount);
      } else {
        bankAccounts[index] = bankAccount;
      }
      dispatch({
        type: UPDATE_BANK_ACCOUNT_SAGA,
        bankAccounts,
        bankAccount,
      });
    };
  },
  deleteBankAccount: id => {
      return (dispatch, getState) => {
        const bankAccounts = getState().BankAccounts.bankAccounts;
        const newBankAccounts = [];
        bankAccounts.forEach(bankAccount => {
          if (bankAccount._id !== id) {
            newBankAccounts.push(bankAccount);
          }
        });
        dispatch({
          type: DELETE_BANK_ACCOUNT_SAGA,
          bankAccounts: newBankAccounts,
          bankAccount: id,
        });
      };
  },
};

export default actions;